var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Line } from "vue-chartjs";
import { Vue, Component, Prop } from "vue-facing-decorator";
import { Chart as ChartJS, CategoryScale, PointElement, LineElement, Title, Tooltip, Legend, TimeScale, LinearScale } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import annotationPlugin from 'chartjs-plugin-annotation';
ChartJS.register(CategoryScale, LinearScale, TimeScale, PointElement, LineElement, Title, Tooltip, Legend, zoomPlugin, annotationPlugin);
let DischargeReportFilterGraph = class DischargeReportFilterGraph extends Vue {
    constructor() {
        super(...arguments);
        this.canPlot = false;
    }
    mounted() {
        this.plot();
    }
    ;
    plot() {
        if (!this.chartData)
            return;
        this.renderOptions = Object.assign({}, this.options);
        this.renderData = JSON.parse(JSON.stringify(this.chartData));
        this.canPlot = this.renderData.datasets && this.renderData.datasets.length > 0;
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof ChartObject !== "undefined" && ChartObject) === "function" ? _a : Object)
], DischargeReportFilterGraph.prototype, "chartData", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_b = typeof Object !== "undefined" && Object) === "function" ? _b : Object)
], DischargeReportFilterGraph.prototype, "options", void 0);
DischargeReportFilterGraph = __decorate([
    Component({
        components: {
            Line
        }
    })
], DischargeReportFilterGraph);
export default DischargeReportFilterGraph;
